import RadioGroup from "../form/RadioGroup";
import Button1 from "../form/Button1";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { MenuItem, Modal } from "@mui/material";
import card from "../../assets/icons/payment/card-payment.svg";
import wallet from "../../assets/icons/payment/wallet.svg";
import TextInput from "../form/TextInput";
import getSavedCards from "../../controllers/Bank/getSavedCards";
import { getsubDomain, isCustomerSite } from "../../utils/getsubDomain";
import { configurations } from "../../configurations";
import PaymentMethodCardSelection from "./PaymentMethodCardSelection";
import OdiopayInfoModal from "../modal/OdiopayInfoModal";
import OdiopayPaymentModal from "../modal/OdiopayPaymentModal";

export default function PaymentMethod2({
  className,
  hide,
  handlePay,
  paymentLoading,
  service,
  booking,
}) {
  const customer = isCustomerSite();
  const agency = getsubDomain();

  const options = [
    {
      iconString: "/paymentOptionNewCard.svg",
      icon: (
        <img alt="" src="/paymentOptionNewCard.svg" className="!min-w-[28px]" />
      ),
      name: "Pay instantly with a new card",
      description: "Pay with a debit or credit card",
      value: configurations.payment.methods.newCard.code,
    },
  ];

  if (!customer)
    options.push({
      iconString: "/paymentOptionWallet.svg",
      icon: <img alt="" src={wallet} className="" />,
      name: "Pay via Intraverse wallet",
      description: "Easily pay with your available wallet balance",
      value: configurations.payment.methods.wallet.code,
    });
  if (service === configurations.products.flight.value && booking) {
    options.push({
      iconString: "/paymentOptionOdiopay.svg",
      icon: <img alt="" src={wallet} className="" />,
      name: "Price freeze with Odiopay",
      description: "Pay in installments",
      value: configurations.payment.methods.odiopay.code,
      info: true,
    });
  }

  if (!customer && !agency)
    options.push({
      iconString: "/paymentOptionStoredCard.svg",
      icon: <img alt="" src={card} className="" />,
      name: "Pay with stored card",
      description: "Make payment with a saved card",
      value: configurations.payment.methods.savedCard.code,
      Footer: () => (
        <TextInput
          select
          noShrink
          value={selectedCard}
          onChange={(ev) => setSelectedCard(ev?.target?.value)}
          label={"Select a card"}
        >
          <div className="w-full flex justify-center items-center">
            {loadingCards ? <div className="load text-primary"></div> : null}
          </div>
          {cards?.map((card, i) => (
            <MenuItem value={card?._id} key={i}>
              <div className="flex gap-4 justify-between items-center w-full">
                <div>
                  <b>{card?.bank}</b>
                  <p>
                    {card?.bin} {card?.last4}
                  </p>
                </div>
                <div className="flex flex-col gap-1 text-xs">
                  <span className="flex gap-2 justify-between">
                    EXPIRY{" "}
                    <span>
                      {card?.exp_month}/{card?.exp_year}
                    </span>
                  </span>
                  <span className="flex gap-2 justify-between">
                    {card?.channel} <span>{card?.card_type}</span>
                  </span>
                </div>
              </div>
            </MenuItem>
          ))}
        </TextInput>
      ),
    });

  const [odiopayInfoModal, setOdiopayInfoModal] = useState(false);
  const [odiopayPaymentModal, setOdiopayPaymentModal] = useState(false);
  const [method, setMethod] = useState(options[0].value);
  const [loadingCards, setLoadingCards] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState();

  useEffect(() => {
    if (method === configurations.payment.methods.savedCard.code && !agency)
      loadCards();
  }, [method]);

  async function loadCards() {
    setLoadingCards(true);
    const res = await getSavedCards();
    setLoadingCards(false);
    if (res.return) {
      setCards(res?.data?.data);
      setSelectedCard(res?.data?.data?.at(0)?._id);
    } else enqueueSnackbar(res?.msg, { variant: "error" });
  }

  async function handleHold() {}

  return (
    <div className={" flex flex-col gap-2 w-full" + className}>
      <OdiopayInfoModal open={odiopayInfoModal} setOpen={setOdiopayInfoModal} />
      <OdiopayPaymentModal
        booking={booking}
        open={odiopayPaymentModal}
        setOpen={setOdiopayPaymentModal}
        onPay={(payload) => {
          setOdiopayPaymentModal(false);
          handlePay({
            method: configurations.payment.methods.odiopay.code,
            payload,
          });
        }}
      />
      <div className="flex flex-col w-full">
        {options?.map((option, optionIndex) => (
          <div
            className="cursor-pointer border-b py-6 flex flex-col w-full"
            key={optionIndex}
          >
            <button
              className="gap-3 lg:gap-4 items-center flex w-full"
              onClick={() => {
                setMethod(option.value);
              }}
            >
              <img
                src={option.iconString}
                alt=""
                className="w-8 lg:w-11 h-8 lg:h-11 object-contain"
              />
              <div className="flex flex-1 items-center gap-3 lg:gap-4">
                <div className="flex flex-1 flex-col items-start">
                  <span className="font-medium text-base lg:text-lg flex items-center">
                    {option.name}{" "}
                    {option?.info ? (
                      <button
                        className="ml-2"
                        onClick={() => setOdiopayInfoModal(true)}
                      >
                        {" "}
                        <img
                          src="/IconInfo.svg"
                          alt=""
                          className="w-4 object-contain"
                        />{" "}
                      </button>
                    ) : (
                      ""
                    )}{" "}
                  </span>
                  <span className="text-xs lg:text-sm  text-[#6D7C94]">
                    {option.description}
                  </span>
                </div>
                {method === option.value ? (
                  <div className="w-5 h-5 border-2 rounded-full border-primary1 flex items-center justify-center">
                    <div className="w-3 h-3 rounded-full bg-primary1"></div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </button>
            {option.value === configurations.payment.methods.savedCard.code &&
            method === configurations.payment.methods.savedCard.code ? (
              <PaymentMethodCardSelection
                cards={cards}
                loadingCards={loadingCards}
                selectedCard={selectedCard}
                setSelectedCard={setSelectedCard}
              />
            ) : (
              <></>
            )}
          </div>
        ))}

        <button
          className={`w-full flex items-center justify-center font-bold text-white bg-primary1 rounded-lg mt-4 mb-2 h-12`}
          disabled={paymentLoading}
          onClick={() => {
            if (method === configurations.payment.methods.odiopay.code) {
              setOdiopayPaymentModal(true);
            } else {
              handlePay({ method, savedCard: selectedCard });
            }
          }}
        >
          {paymentLoading ? <div className="buttonLoader"></div> : <>Pay Now</>}
        </button>
      </div>
    </div>
  );
}
